module.exports = (__webpack_require__("U2o4"))("MG6g");